<script lang="ts">
  import ModalShell from './ModalShell.svelte';

  let {
    initialName,
    onSave,
    onCancel,
  }: {
    initialName: string;
    onSave: (next: string) => Promise<void>;
    onCancel: () => void;
  } = $props();

  // svelte-ignore state_referenced_locally
  // The modal is mounted fresh each time the dashboard opens it, so
  // capturing initialName once is the intended behavior.
  let value: string = $state(initialName);
  let saving: boolean = $state(false);
  let error: string | null = $state(null);
  let inputEl: HTMLInputElement | null = $state(null);

  $effect(() => {
    inputEl?.focus();
    inputEl?.select();
  });

  async function onSubmit(e: SubmitEvent) {
    e.preventDefault();
    if (saving) return;
    const trimmed = value.trim();
    if (trimmed === '') {
      error = 'Trip name cannot be empty.';
      return;
    }
    if (trimmed === initialName) {
      onCancel();
      return;
    }
    saving = true;
    error = null;
    try {
      await onSave(trimmed);
    } catch (e) {
      error = e instanceof Error ? e.message : 'Could not rename trip';
      saving = false;
    }
  }
</script>

<ModalShell title="Rename trip" onClose={onCancel} role="dialog" maxWidth={400}>
  <form onsubmit={onSubmit} class="form">
    <label class="field">
      <span class="label">Trip name</span>
      <input
        bind:this={inputEl}
        type="text"
        bind:value
        maxlength="80"
        required
        disabled={saving}
      />
    </label>
    {#if error}
      <p class="error">{error}</p>
    {/if}
    <div class="actions">
      <button class="btn btn-secondary" type="button" onclick={onCancel} disabled={saving}>
        Cancel
      </button>
      <button class="btn btn-primary" type="submit" disabled={saving || value.trim() === ''}>
        {saving ? 'Saving…' : 'Save'}
      </button>
    </div>
  </form>
</ModalShell>

<style>
  .form { display: flex; flex-direction: column; gap: 1rem; }
  .field { display: flex; flex-direction: column; gap: 0.375rem; }
  .label {
    font-size: 12px;
    font-weight: 500;
    color: var(--color-muted);
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }
  input {
    border: 1px solid var(--color-hairline);
    border-radius: var(--radius-sm);
    padding: 0.625rem 0.875rem;
    font-size: 16px;
    color: var(--color-ink);
    background: var(--color-canvas);
    font-family: inherit;
  }
  input:focus {
    outline: none;
    box-shadow: inset 0 0 0 1px var(--color-ink);
  }
  .error { margin: 0; font-size: 13px; color: var(--color-error); }
  .actions {
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
  }
</style>
